
import Layer from "../../../assets/filled/Layer.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function LayerIcon({ className, dataTestid = "LayerIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Layer data-testid={dataTestid} className={classes} {...rest} />
  );
}
